import { render } from "./ShowProductCategory.vue?vue&type=template&id=41887586&scoped=true"
import script from "./ShowProductCategory.vue?vue&type=script&lang=js"
export * from "./ShowProductCategory.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=41887586&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41887586"]])

export default __exports__